import type { ReactNode } from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';

interface EventEntityLinkProps {
    to: string;
    children: ReactNode;
}

/** Показывает связанную сущность с переходом в другую карточку */
export const EventEntityLink = ({ to, children }: EventEntityLinkProps) => {
    const { pathname } = useLocation();
    const isCurrentEntity = Boolean(matchPath(to, pathname));

    return isCurrentEntity
        ? <>{children}</>
        : <Link to={to}>{children}</Link>;
};
